/**
 * Organisation picker helpers for the users page.
 *
 * The canonical list comes from the backend (`cognito-organisations`), which
 * returns every org with a route allow-list plus any org currently held by a
 * user. The frontend additionally unions in the orgs seen on the users already
 * loaded on the page, so an org that exists in Cognito but hasn't been synced
 * to `dashboard_users` yet is still offered.
 */

// Used only if the backend call fails. Mirrors KNOWN_ORGANISATIONS in
// case-delivery-app `utilities/dashboardFunctions/cognitoUsers.js`.
export const FALLBACK_ORGANISATIONS = [
    'Sentinel',
    'ADL',
    'MR',
    'PCPMO26',
    'SentinelMatters',
    'Vision Launch',
    'Sensible',
    'Gorilla',
    'Allegiant',
    'Panaco',
    'FairClaim',
    'MBFCheck',
    'MFC',
    'Funder Audit',
    'Insurance Audit',
    'Score',
    'PCP Referral',
    'PCP Referral Engagement',
    'Military Hearing Loss',
    'Military Hearing Loss Admin',
]

/** Union, trim, de-duplicate and sort (case-insensitive) organisation names. */
export const mergeOrganisations = (...lists: (readonly string[] | undefined | null)[]): string[] => {
    const seen = new Set<string>()
    lists.forEach((list) => {
        ;(list || []).forEach((raw) => {
            const org = (raw || '').trim()
            if (org) seen.add(org)
        })
    })
    return Array.from(seen).sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }))
}
